import React from "react";
import "./InlineInfoTooltip.scss";
import { Tooltip } from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";
import type { DocumentedComponent } from "./DocumentedComponent";

interface Props {
    text: React.ReactNode
}

const InlineInfoTooltip = (props: Props) => {
    const { text } = props;

    return (
        <Tooltip title={text}>
            <HelpIcon className="inline-info-tooltip" />
        </Tooltip>
    );
}

(InlineInfoTooltip as DocumentedComponent).metadata = {
    description: "The `InlineInfoTooltip` component renders an 'info' icon inline with the current content.  This icon displays a tooltip containing the provided text/content when the user hovers over it.",
    attributes: [
        {
            name: "text",
            description: "The content to display when the user hovers over the icon.",
            type: "string",
            exactType: "React.ReactNode"
        }
    ],
    isSelfClosing: true
}

export default InlineInfoTooltip;